import { Accordion, createAccordion } from '@vfde-brix/ws10/accordion';
import { HtmlId } from '../enums/elementId';
import { trackFaqAccordionShown } from '../tracking/tracking';
import { createComponentById } from '@vfde-brix/ws10/core';

/**
 * Create Brix Accordion component.
 * @param {HtmlId} id - Wrapper ID of the element.
 * @returns {Accordion|null} - Accordion component or null if element with given id is not found.
 */
export const mountAccordion = (id: HtmlId): Accordion | null =>
    createComponentById(createAccordion, id, {
        onToggle: (props) => {
            if (props.optOpen) {
                trackFaqAccordionShown(props.stdHeadline);
            }
        },
    });

/**
* Closes all items inside an accordion
* @param {Accordion} comp - accordion to update
*/
export const closeAccordion = (comp: Accordion) => {
    const { items } = comp.getProperties();

    for (const item of items) {
        item.optOpen = false;
    }

    comp.update({ items });
};
